import { MapUtils } from '../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../dto/data-model-utils.js';
import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../../dto/data-model.js';
import { OpenAccessPass } from '../../open-access-pass/open-access-pass.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class SeatedOpenAccessPassMovedEntry extends AuditLogEntry {
  static readonly TYPE_ID = '83a6db6a65dc4a5293c40eeaf6b400da';

  private constructor(
    public readonly before: OpenAccessPass,
    public readonly after: OpenAccessPass,
    public readonly oldSeatId: number | null,
    public readonly newSeatId: number | null,
  ) {
    super();
  }

  get $typeId(): string {
    return SeatedOpenAccessPassMovedEntry.TYPE_ID;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      passId: this.after.uniqueId,
      orderId: this.after.orderId,
    };
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.SeatedEventOpenAccessPassMoved;
  }

  static create(args: {
    before: OpenAccessPass,
    after: OpenAccessPass,
    oldSeatId: number | null,
    newSeatId: number | null,
  }): SeatedOpenAccessPassMovedEntry {
    return new SeatedOpenAccessPassMovedEntry(
        args.before,
        args.after,
        args.oldSeatId,
        args.newSeatId,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatedOpenAccessPassMovedEntry {
    return this.create({
      before: context.fromData<OpenAccessPass>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<OpenAccessPass>(MapUtils.getRecord(map, 'after')),
      oldSeatId: MapUtils.getNumberOrNull(map, 'oldSeatId'),
      newSeatId: MapUtils.getNumberOrNull(map, 'newSeatId'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
      oldSeatId: this.oldSeatId,
      newSeatId: this.newSeatId,
    };
  }

  clone(): this {
    return new SeatedOpenAccessPassMovedEntry(
        cloneData(this.before),
        cloneData(this.after),
        this.oldSeatId,
        this.newSeatId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
      isSameData(other.after, this.after) &&
      other.oldSeatId === this.oldSeatId &&
      other.newSeatId === this.newSeatId;
  }
}

export class SeatedOpenAccessPassMovedEntryBuilder extends DataModelBuilder<SeatedOpenAccessPassMovedEntry> {
  build(context: SerializationContext, map: SerializedData): SeatedOpenAccessPassMovedEntry {
    return SeatedOpenAccessPassMovedEntry.fromMap(context, map);
  }
}
